<template>
  <div class="no_data_wrap">
    <p class="no_data_text">{{ $t('FoodC_bill_Bspm_MYZN') }}</p>
    <div class="no_data_button">
      <rich-button :inline="true" size="small" @click="clickHandler">{{
        $t('FoodC_bill_dUjM_rVQW')
      }}</rich-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberCard',
  components: {},
  props: {
    linkInfo: {
      type: Object,
      default: () => {},
    },
    selectedLabelDefault: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    clickHandler() {
      this.SodaBridge('openPage', {
        target: 'blank',
        url: this.linkInfo[this.selectedLabelDefault],
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.no_data_wrap {
  padding: 120px 0;
  .no_data_text {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 36px;
  }
  .no_data_button {
    margin-top: 32px;
    text-align: center;
    ::v-deep .rich-btn {
      background: #ff5f14;
    }
  }
}
</style>
